import { render, staticRenderFns } from "./tableTotalAmount.vue?vue&type=template&id=dbff29c2&"
import script from "./tableTotalAmount.vue?vue&type=script&lang=js&"
export * from "./tableTotalAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports